import { PublicLayout } from "../../components/Layout/PublicLayout";
import ProfileDirections from "../../components/Profile/ProfileDirections/ProfileDirections";
const breadcrumbsData = [
  {
    label: "Perfil",
    path: "/profile",
  },
  {
    label: "Mis Direcciones",
    path: "/profile/directions",
  },
];
const OrdersProfile = () => {
  return (
    <PublicLayout
      breadcrumb={breadcrumbsData}
      breadcrumbTitle='Mis Direcciones'
    >
      <ProfileDirections />
    </PublicLayout>
  );
};

export default OrdersProfile;
